var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"v-display no-select"},[_c('router-view'),_c('m-navigation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }